<template>
  <div id="map">
    <img
      @click="handleShowLeftPopup"
      class="map-left_switch"
      src="../../assets/images/map_left_switch.svg"
      alt=""
    />
    <!-- <a href="http://fyworkshop.com/roamwuyi/" target="_blank">
      <img class="map-go_back" src="../../assets/images/shuzihua.jpg" />
    </a> -->
    <!-- <ul class="map-go_back">
      <li v-for="(item, index) in targetList" :key="index">
        <el-button type="primary"
          ><a :href="item.value" target="_blank">{{ item.label }}</a></el-button
        >
      </li>
    </ul> -->
    <!-- <img
      v-if="isMobile && searchNearly"
      class="map-search-near"
      :src="require('../../assets/images/gis-map_update.svg')"
      @click="handleSearchNearly"
      alt="更新"
    /> -->
    <map-bottom-popup-vue
      v-model="showBottomPopup"
      :mapRelicDetail="mapRelicDetail"
      v-if="showBottomPopup"
    />
    <map-left-popup-vue
      v-model="showLeftPopup"
      :relicCountData="relicCountData"
      v-if="relicCountData"
      @onChangeByFilter="handleChangeByFilter"
      @onSearchSuccessRelic="handleSearchSuccessRelic"
    />
    <div id="map-container" class="map-container"></div>
  </div>
</template>

<script>
import mapBottomPopupVue from '../../components/map/map-bottom-popup.vue';
import mapLeftPopupVue from '../../components/map/map-left-popup.vue';
import { initAMap, geolocation, mapGeolocation } from '../../config/AMap';
import { wgs84togcj02 } from '../../config/transformCoodornate';
import {
  getRelicCountByKind,
  getMapPoints,
  searchRelicListInMap,
  getMapRelicDetail,
  getMapRelicDetailPublic,
  createRelic,
  updateRelicBasicDetail
} from '../../api';
import {
  TYPE_MAP,
  LEVEL_MAP,
  AREA_MAP,
  transformMap
} from '../../config/constant';
import { mapGetters, mapMutations } from 'vuex';
import { roleJudge } from '../../config/roleJudge';
let gridSize = 60;
export default {
  name: 'Map',
  components: {
    mapBottomPopupVue,
    mapLeftPopupVue
  },
  computed: {
    ...mapGetters('login', ['authToken', 'authorizationLimit', 'isMobile']),
    searchNearly() {
      return roleJudge(this.authorizationLimit, 4);
    }
  },
  data() {
    return {
      timer: null,
      inspectorLimit: false,
      mapRelicDetail: null, //保存地图建筑详情的
      geolocation: '', //自身定位信息
      points: [],
      cluster: '',
      renderClusterMarker: '', //聚合点
      renderMarker: '', //非聚合点
      showBottomPopup: false,
      showLeftPopup: false,
      relicCountData: {},
      map: '',
      AMap: '',
      relicDetail: {}, //建筑详情
      choosedMakerId: ''
    };
  },
  // watch: {
  //   geolocation() {
  //     // this.cluster.setData()
  //     this.cluster?.setData();
  //     this.initMarkerClusterer({
  //       AMap: this.AMap,
  //       map: this.map,
  //       points: this.points
  //     });
  //   },
  //   $router() {
  //     clearInterval(this.timer);
  //   }
  // },
  mounted() {
    getMapPoints().then(res => {
      if (res.data.code == 200) {
        this.inspectorLimit = this.authorizationLimit.some(e => {
          return e == 4;
        });
        this.points = res.data.data;
        this.points = this.points.filter(e => {
          return e.coordinate?.x;
        });
        this.points.forEach(e => {
          e.lnglat = wgs84togcj02(e.coordinate.x, e.coordinate.y);
        });
        this.initMap(this.points);
      }
    });
    setInterval(() => {
      if (this.searchNearly && this.isMobile) {
        this.initLocation({
          AMap: this.AMap,
          map: this.map,
          points: this.points
        });
      }
    }, 5000);
  },
  methods: {
    handleGoBack() {
      if (this.authToken) {
        this.$router.push({ name: 'Relic' });
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
    /**
     * * 初始化地图
     */
    async initMap(points) {
      const { AMap, map } = await initAMap({
        options: {
          zoom: 10,
          resizeEnable: true,
          expandZoomRange: true,
          zooms: [3, 20],
          scrollWheel: true
        },
        container: 'map-container',
        plugins: [
          'AMap.Geolocation',
          'AMap.AutoComplete',
          'AMap.PlaceSearch',
          'AMap.MarkerClusterer'
        ]
      });
      this.AMap = AMap;
      this.map = map;
      map.setMapStyle('amap://styles/d66496f8448a7ff8aa2e4ae408157a92');
      // this.initMarker({ AMap, map, relicList: this.relicList });
      // if (this.authToken && this.inspectorLimit) {
      //   this.timer = setInterval(() => {
      //     this.initLocation({ AMap, map, points });
      //   }, 5000);
      //   // this.initLocation({ AMap, map, points });
      //   // this.initLocation({ AMap, map });
      // }
      map.setCenter([120.223637, 29.994095]);
      // this.initMarkerClusterer({ AMap, map, points });
      this.initMarkerClusterer({ AMap, map, points });
    },
    /**
     * 引入点聚合
     */
    async initMarkerClusterer({ AMap, map, points }) {
      // points.forEach(e => {
      //   e.lnglat = [];
      //   e.lnglat[0] = e.coordinate.x;
      //   e.lnglat[1] = e.coordinate.y;
      // });
      points = this.points.filter(e => {
        return e.coordinate?.x;
      });
      if (!points[0].lnglat) {
        points.forEach(e => {
          // e.lnglat = [];
          // e.lnglat[0] = e.coordinate.x;
          // e.lnglat[1] = e.coordinate.y;
          e.lnglat = wgs84togcj02(e.coordinate.x, e.coordinate.y);
        });
      }
      //聚合点样式
      this.renderClusterMarker = function(context) {
        //
        let content = '';
        const visibleGaoLiang = context.clusterData.some(item => {
          return item.gaoLiang;
        });
        const markerStyle = visibleGaoLiang
          ? 'marker-style gao-liang-marker'
          : 'marker-style normal-marker';
        if (context.clusterData[0].coverUrl) {
          content = `<div class='${markerStyle}'><img class="marker-style-img" src="${context.clusterData[0].coverUrl}"/><div class="marker-style-number">${context.count}</div></div>`;
        } else {
          content = `<div class='${markerStyle}'><div class="marker-style-number">${context.count}</div></div>`;
        }

        context.marker.setOffset(new AMap.Pixel(-37, -82));
        context.marker.setContent(content);
        context.marker.on('click', () => {
          // map.addControl(context.clusterData[0].lnglat);
          // map.setFitView(context.clusterData[0].lnglat);
          let currentZoom = map.getZoom();
          map.setZoom(currentZoom + 2);
          map.setCenter(context.clusterData[0].lnglat);
        });
      };
      //非聚合点样式
      let that = this;
      this.renderMarker = function(context) {
        let content = '';
        // console.log(1131234123);
        const markerStyle = context.data[0].highLight
          ? 'marker-style gao-liang-marker'
          : 'marker-style normal-marker';
        if (context.data[0].coverUrl) {
          content = `<div class='${markerStyle}' data-id='${that.choosedMakerId}'><img class="marker-style-img" src="${context.data[0].coverUrl}"/></div>`;
        } else {
          content = `<div class='${markerStyle}' data-id='${that.choosedMakerId}'><div class="marker-style-relicID">${context.data[0].relicName[0]}</div></div>`;
        }
        let offset = new AMap.Pixel(-37, -82);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
        context.marker.on('click', marker => {
          // const content = `<div class='marker-style gao-liang-marker'><img class="marker-style-img" src="${context.data[0].coverUrl}"/></div>`;
          // context.marker.setContent(content);
          // const test = marker.getContent();
          // that.choosedMaker = marker;
          //   'marker-style gao-liang-marker';
          that.searchRelicDetailInMap(
            context.data[0].relicAutoIncrementId,
            map
          );
          // let test = map.getZoom();
          // map.setZoom(test);
          map.setCenter(context.data[0].lnglat);
        });
        context.marker.setTitle(
          `建筑编号：${context.data[0].relicFromUserId}\n建筑名称：${context.data[0].relicName}`
        );
        // console.log(
        //   context.marker.dom.firstChild.dataset.id,
        //   that.choosedMakerId
        // );
        // if (that.choosedMakerId == context.marker.dom.firstChild.dataset.id) {
        // let content = `<div class='marker-style gao-liang-marker' data-id='${that.choosedMakerId}'><img class="marker-style-img" src="${context.data[0].coverUrl}"/></div>`;
        // context.marker.setContent(content);
        // }
      };
      this.cluster = new AMap.MarkerCluster(map, points, {
        gridSize: gridSize, // 设置网格像素大小
        renderClusterMarker: this.renderClusterMarker, // 自定义聚合点样式
        renderMarker: this.renderMarker, // 自定义非聚合点样式
        maxZoom: 20,
        averageCenter: true
      });
    },
    /**
     * * 初始化定位
     */
    async initLocation({ AMap, map, points }) {
      const test = await geolocation({ AMap, map });
      if (test.info == 'LOCATE_SUCCESS') {
        const {
          position: { lng, lat }
        } = test;
        points.forEach(e => {
          let distance = AMap.GeometryUtil.distance([lng, lat], e.lnglat);
          //
          if (distance > 50) {
            e.gaoLiang = false;
          } else {
            e.gaoLiang = true;
          }
        });
        this.cluster?.setData?.();
        //
        await this.initMarkerClusterer({ AMap, map, points });
      }
    },

    /**
     * 搜寻附近建筑
     */
    handleSearchNearly() {
      this.initLocation({
        AMap: this.AMap,
        map: this.map,
        points: this.points
      });
    },

    /**
     * 本地定位
     */
    async initLoacl() {
      return new Promise((reslove, reject) => {
        navigator.geolocation.getCurrentPosition(function(position) {
          //
          const {
            coords: { longitude, latitude }
          } = position;
          const test = wgs84togcj02(longitude, latitude);
          reslove(test);
        });
      });
    },

    /**
     * 显示建筑详情回调
     */
    handleshowRelicPoPup() {
      this.showBottomPopup = true;
    },
    /**
     * 显示左侧弹窗回掉
     */
    handleShowLeftPopup() {
      this.showBottomPopup = false;
      if (!this.showLeftPopup) {
        getRelicCountByKind().then(res => {
          if (res.data.code == 200) {
            const { data } = res.data;
            data.relicTypecounts.forEach(e => {
              e.label = TYPE_MAP.get(e.propertyEnum);
            });
            data.relicAddresscounts.forEach(e => {
              e.label = AREA_MAP.get(e.propertyEnum);
            });
            data.protectionLevelcounts.forEach(e => {
              e.label = LEVEL_MAP.get(e.propertyEnum);
            });
            this.relicCountData = data;
            this.showLeftPopup = true;
          }
        });
      } else {
        this.showLeftPopup = false;
      }
    },
    handleChangeByFilter(levelList, addressList, typeList) {
      //
      let protectionLevelEnums = levelList.join('&protectionLevelEnums=');
      let relicDistrictEnums = addressList.join('&relicDistrictEnums=');
      let relicTypeEnums = typeList.join('&relicTypeEnums=');

      searchRelicListInMap({
        protectionLevelEnums,
        relicTypeEnums,
        relicDistrictEnums
      }).then(res => {
        //
        if (res.data.code == 200) {
          this.points = res.data.data.items;
          //
          this.cluster.setData(); //清除聚合点
          // // this.cluster.getMarkers();
          this.points = this.points.filter(e => {
            return e.coordinate?.x;
          });
          this.points.forEach(e => {
            // e.lnglat = [];
            // e.lnglat[0] = e.coordinate.x;
            // e.lnglat[1] = e.coordinate.y;
            e.lnglat = wgs84togcj02(e.coordinate.x, e.coordinate.y);
          });
          this.initMarkerClusterer({
            map: this.map,
            AMap: this.AMap,
            points: this.points
          });
          // this.initLocation({
          //   AMap: this.AMap,
          //   map: this.map,
          //   points: this.points
          // });
        }
      });
    },
    /**
     * 监听成功找到建筑
     */
    handleSearchSuccessRelic(relicId) {
      this.searchRelicDetailInMap(relicId, this.map);
    },
    /**
     * 地图查询建筑详情
     */
    searchRelicDetailInMap(relicId, map) {
      this.cluster.setData();
      this.points = this.points.filter(e => {
        return e.coordinate?.x;
      });
      this.points.forEach(e => {
        // e.lnglat = [];
        // e.lnglat[0] = e.coordinate.x;
        // e.lnglat[1] = e.coordinate.y;
        e.highLight = e.relicAutoIncrementId == relicId ? true : false;
        e.lnglat = wgs84togcj02(e.coordinate.x, e.coordinate.y);
      });
      this.initMarkerClusterer({
        map: this.map,
        AMap: this.AMap,
        points: this.points
      });
      // this.choosedMaker.target.dom.firstChild.className =
      //   'marker-style gao-liang-marker';
      this.showLeftPopup = false;
      this.choosedMakerId = relicId;
      if (this.authToken) {
        getMapRelicDetail(relicId).then(res => {
          if (res.data.code == 200) {
            let { coordinate } = res.data.data.relicEditPageInfoDTO;
            let lnglat = wgs84togcj02(coordinate.x, coordinate.y);
            this.setRelicDetail(res.data.data.relicEditPageInfoDTO);
            // let lnglat = [coordinate.x, coordinate.y];
            map.setCenter(lnglat);
            map.setZoom(20);
            this.mapRelicDetail = res.data.data;

            this.showBottomPopup = true;
          }
        });
      } else {
        getMapRelicDetailPublic(relicId).then(res => {
          if (res.data.code == 200) {
            let { coordinate } = res.data.data.relicEditPageInfoDTO;
            this.setRelicDetail(res.data.data.relicEditPageInfoDTO);
            let lnglat = wgs84togcj02(coordinate.x, coordinate.y);
            // let lnglat = [coordinate.x, coordinate.y];
            map.setCenter(lnglat);
            map.setZoom(20);
            this.mapRelicDetail = res.data.data;

            this.showBottomPopup = true;
          }
        });
      }
    },
    ...mapMutations('relic', ['setRelicDetail'])
  }
};
</script>

<style lang="scss">
#map {
  position: relative;
  width: 100vw;
  height: 100vh;
  .map-left_switch {
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 1500;
    width: 32px;
    height: 32px;
  }
  .map-search-near {
    position: fixed;
    top: 50vh;
    right: 15px;
    z-index: 1500;
    width: 40px;
    height: 40px;
  }
  .map-go_back {
    position: fixed;
    top: 15px;
    right: 15px;
    z-index: 300;
    .el-button {
      width: auto;
      padding: 5px 10px;
      margin: 10px 0px;
      a {
        color: #fff !important;
      }
    }
  }
  .map-container {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    z-index: 100;
  }
  .gao-liang-marker {
    background: no-repeat center url('../../assets/images/din-wei_red.png');
  }
  .normal-marker {
    background: no-repeat center url('../../assets/images/map_zuobiao.png');
  }
  .marker-style {
    display: flex;
    position: relative;
    justify-content: center;
    width: 75px;
    height: 82px;
    background-size: contain;
    &-img {
      width: 37px;
      height: 37px;
      margin-top: 19px;
      border-radius: 50%;
    }
    &-number {
      position: absolute;
      right: 0px;
      border-radius: 50%;
      width: 26px;
      height: 26px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 26px;
      background-color: #fa6161;
    }
    &-relicID {
      position: absolute;
      font-size: 16px;
      color: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
